import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class Ofertes {
  private apiUrl = `${this.SharedProperties.baseUrlService()}/MOE/services/ofertes`;

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $q: ng.IQService,
    private $http: ng.IHttpService,
  ) { }

  getOfertaCentre(centre: any, params?): ng.IPromise<any> {
    const config = {
      params: {
        codiCentre: centre.codiCentre || centre.codi,
        educacioEspecial: paramsMapes.educacioEspecial,
        ...(params ? params : {}),
      },
    };

    return this.$http
      .get(`${this.apiUrl}/findOfertaCentre?`, config)
      .then((response: any) => response.data)
      .catch((error: any) => {
        console.error(error);
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        window.scrollTo(0, 0);
        return this.$q.reject(error);
      });
  }
}

angularJsApp.service(AppServicesEnum.OFERTES_SERVICE, Ofertes);